export const scheduleStatusEnum = {
  'NO_SETTINGS': 'tools.project.arming.status.noSettings',
  'ARMED': 'tools.project.arming.status.armed',
  'CAPTURE': 'tools.project.arming.status.capture',
  'NO_DEVICES': 'tools.project.arming.status.noDevices',
}